
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById"

  const API = {
    GET: "/api/admin/projects",
    ADD: "/api/admin/projects",
    UPDATE: "/api/admin/projects",
    DELETE: "/api/admin/projects",
  };

  const KEY = "PROJECTS";
  export const useGetProjects = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddProjects = () => useAddMutation(KEY, API.ADD);
  export const useUpdateProjects = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteProjects = () =>useDeleteMutation(KEY, API.DELETE);
